export default __webpack_public_path__ + "static/46-fit-96e7621e85b50c25ad10437c492df425.png";